import { Component, input } from '@angular/core';

import { PrivaCardComponent } from '@priva/components/card';
import { PrivaLocalizationModule } from '@priva/localization';

import { TileListUtils } from 'app/shared/components/tile-list/tile-list.utils';

import { Tile } from '../models';

@Component({
    selector: 'app-tile',
    templateUrl: './tile.component.html',
    styleUrl: './tile.component.scss',
    imports: [PrivaCardComponent, PrivaLocalizationModule],
})
export class TileComponent {
    tile = input<Tile>();
    tileListUtils = TileListUtils;
}
